import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { MessagePlugin } from 'tdesign-react';

import { HomeDataManagerType } from '@/const/promotion';
import { Story } from '@/interface/promotion';
import { CgiErrorCode } from '@/services/cgi';
import { fetchPromotionDetail } from '@/services/promotion';

interface StateInfo {
  id?: string;
  name?: string;
  promotionList?: {
    homeDataId?: string;
    managerType?: HomeDataManagerType
    style?: HomeDataManagerType;
    id?: string;
    stories?: Story;
  }[];
  materialMap: Record<string, string>
}

export interface PromotionState {
  promotionInfo: StateInfo,
  loading: boolean;
}

const initialState: PromotionState = {
  promotionInfo: {
    promotionList: [],
    materialMap: {},
  },
  loading: false,
};

export const getPromotionDetail = createAsyncThunk('promotion/detail', fetchPromotionDetail);
export const promotion = createSlice({
  name: 'basic',
  initialState,
  reducers: {
    initPromotion() {
      return {
        ...initialState,
      };
    },
    updatePromotionInfo(state, action) {
      state.promotionInfo = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPromotionDetail.fulfilled, (state, { payload }) => {
      if (payload?.code !== CgiErrorCode.NO_ERROR) {
        MessagePlugin.error(payload?.message || '请求失败，请重试');
        return ({
          ...state,
          loading: false,
        });
      }
      return ({
        ...state,
        loading: false,
        promotionInfo: payload?.data as StateInfo,
      });
    });
  },
});

export const { updatePromotionInfo, initPromotion, setLoading } = promotion.actions;

export default promotion.reducer;
